<template>
  <v-container>

    <v-row class="divider">
      <v-col
          md="3">
        <v-overflow-btn
            v-model="classNameFilter"
            label="Class"
            :items="uniqueClassNames"
            :auto-select-first="true"
        ></v-overflow-btn>
      </v-col>
      <v-col>
        <v-checkbox
            v-model="hideComplete"
            :label="`Hide complete races`"
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-row v-for="(race) in racesForRounds" v-bind:key="race.totalRaceNumber"
           v-bind:class="{'divider':race.lastRaceInRound,'light-divider':!race.lastRaceInRound}">
      <template v-if="!hideComplete || (hideComplete && (!race.winner||!race.result))">
        <v-col style="padding:6px">
          <div class="raceNumber">{{ race.totalRaceNumber }}</div>
          <div style="float:left">
            <div class="entryLabel">P</div>
            <div class="boatGroupIndicator" v-bind:title="race.team1Boat.reference"
                 v-bind:style="{ 'background-color': '#'+race.team1Boat.rgb}"></div>
            <div style="float:left"><div class="teamNumber">{{ race.team1.teamId }}</div>
              <div style="float:left">- {{ race.team1.name }}({{race.team1.initialSeed}})</div>
            </div>
            <div class="entryLabel" style="clear:both">S</div>
            <div class="boatGroupIndicator" v-bind:title="race.team2Boat.reference"
                 v-bind:style="{ 'background-color': '#'+race.team2Boat.rgb}">
            </div>
            <div style="float:left"><div class="teamNumber">{{ race.team2.teamId }}</div>
              <div style="float:left">- {{ race.team2.name }}({{race.team2.initialSeed}})</div>
            </div>
          </div>
          <div style="float:left;margin-left:5px">
            <div v-if="race.result" style="float:left">&nbsp;{{ race.result[race.team1.teamId] }}
              <template v-if="race.winner===race.team1.teamId">&nbsp;<span class="winners">WIN</span></template>
            </div>
            <div v-if="race.result" style="clear:both">&nbsp;{{ race.result[race.team2.teamId] }}
              <template v-if="race.winner===race.team2.teamId">&nbsp;<span class="winners">WIN</span></template>
            </div>
          </div>
          <div style="float:right" v-if="!race.result || !race.winner || $store.getters.displayExtras">
            <v-btn link
                   v-on:click="goTo('/result/'+classNameFilter+'/'+race.roundNumber+'/'+race.raceCount)">
              ENTER
            </v-btn>
          </div>
        </v-col>
      </template>
    </v-row>

  </v-container>

</template>

<script>
import {teams} from "@/utils/teams";
//import {rounds} from "@/utils/rounds";

export default {

  data: () => ({
    classNameFilter: "Optimist",
    hideComplete: true
  }),
  methods: {
    goTo: function (path) {
      this.$router.push({path: path}).catch(() => {
      });
    }
  },
  computed: {
    uniqueClassNames: teams.uniqueClassNames,
    racesForRounds: function () {
      if (!this.$store.state.rounds) {
        return [];
      }
      const ret = [];
      let totalRaceNumber = 1
      this.$store.state.rounds.forEach((round) => {
        let raceCount = 0;
        round.races.forEach((race) => {
          race.totalRaceNumber = totalRaceNumber;
          race.roundNumber = round.number;
          raceCount++;
          if (raceCount === this.$store.state.teams.length/2) {
            race.lastRaceInRound = true;
          }
          race.raceCount = raceCount
          ret.push(race);
          totalRaceNumber++;
        })
      })
      return ret;
      //return ret.sort((a, b) => (a.number < b.number) ? 1 : -1);
    }
  }
}
</script>

<style>
.boatGroupIndicator {
  width: 20px;
  height: 20px;
  border-radius: 2px;
  border: 1px solid #333;
}

.raceNumber {
  float: left;
  min-width: 40px;
  padding-top: 5px;
  padding-left: 5px;
  font-size: 24px;
}

.entryLabel {
  float: left;
  font-size: small;
  margin: 0 5px;
  width:8px;

}

.divider {
  border-bottom: 1px solid #666666 !important;
}

.light-divider {
  border-bottom: 1px solid #eeeeee;
}
</style>